module.exports = __webpack_public_path__ + "static/media/hero.e7966195.png";